import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { type SizeType } from 'antd/es/config-provider/SizeContext';
import { useWatch } from 'react-hook-form';
import { ExpressionType } from '../../../IExpression.ts';
import { type IReference } from '../../../references/IReference.ts';
import { ConditionsListInput } from '../../condition/input/ConditionsListInput.tsx';
import {
  ConditionGroupOperator,
  type IConditionGroupExpression,
} from '../IConditionGroupExpression.ts';
import { $NestedConditionGroupWrapper } from './ConditionGroupInput.styled.tsx';

export interface IConditionGroupInputProps {
  name: string;
  references: IReference[];
  nested?: boolean;
  size?: SizeType;
}

const ConditionGroupOperatorOptions = [
  { value: ConditionGroupOperator.And, label: 'tutte' },
  { value: ConditionGroupOperator.Or, label: 'almeno una' },
];

/**
 * Punto di ingresso per l'editor di una condizione (regola) dinamica del
 * motore di configurazione e validazione.
 */
export function ConditionGroupInput(props: IConditionGroupInputProps) {
  const { name, references, nested, size } = props;

  const expression: IConditionGroupExpression = useWatch({
    name: props.name,
    defaultValue: {
      type: ExpressionType.ConditionGroup,
      conditions: [],
      operator: ConditionGroupOperator.And,
    },
  });

  return (
    <$NestedConditionGroupWrapper nested={nested}>
      Se{' '}
      <SelectInput
        style={{ width: 'auto' }}
        popupMatchSelectWidth={false}
        size={size || 'middle'}
        name={`${name}.operator`}
        placeholder="Seleziona..."
        options={ConditionGroupOperatorOptions}
      />{' '}
      {expression?.operator === ConditionGroupOperator.And ? 'le' : 'delle'}{' '}
      seguenti condizioni{' '}
      {expression?.operator === ConditionGroupOperator.And
        ? 'sono verificate'
        : 'è verificata'}
      :
      <ConditionsListInput
        name={`${name}.conditions`}
        references={references}
        allowGroup={!nested}
        size={size || 'middle'}
      />
    </$NestedConditionGroupWrapper>
  );
}
